module.exports = __webpack_public_path__ + "static/media/3DPPA40.3b12da40.jpg";